const powerBiReportPage = '';

export const PowerBiReportPageReducer = (state = powerBiReportPage, action: any) => {
    if (action.type === 'POWERBI_REPORT_PAGE_UPDATE') {
        state = action.payload;
    }
    return state;
}